import Level3Title from './title/Level3Title';
// import './CardComponent.scss';

interface CardComponentProps {
    title?: string;
    toolbar?: JSX.Element | JSX.Element[];
    footer?: JSX.Element | JSX.Element[];
    children: JSX.Element | JSX.Element[];
    customClass?: string;
}

const CardComponent = ({title, toolbar, footer, children, customClass}: CardComponentProps): JSX.Element => {
    return (
        <div className={"card mb-5 mb-xl-10 mt-10" + {customClass}}>
            <div className="card-header">
                {title && (
                    <div className="card-title m-0">
                        <Level3Title title={title} />
                    </div>
                )}
                {toolbar && <div className="card-toolbar">{toolbar}</div>}
            </div>
            <div className="card-body p-9">
                {children}{' '}
                {footer && (
                    <div className="card-footer pe-0 d-flex justify-content-end">{footer}</div>
                )}
            </div>
        </div>
    );
};

export default CardComponent;
